export const getCallingGuest = guestCalling => {
    if (!guestCalling || guestCalling.first_name === 'Новый гость') return null

    return {
        id: guestCalling.id,
        first_name: guestCalling.first_name,
        is_vip: guestCalling.is_vip,
        is_blacklisted: guestCalling.is_blacklisted,
        json_notes: guestCalling.json_notes,
    }
}

export const getCallingPhone = guestCalling =>
    guestCalling?.contacts?.find(e => e.contact_type?.code === 'phone')
        ?.value || ''
